import { axios } from '..';
import { ConfigurationValues } from '../../../components/BtoConfigurator/ConfigurationValues';

export const getMdtCode = async (legacyCode: string, countryCode: string): Promise<any> => {
  return axios
    .get('https://carconfiguratorapi-k.vwfs.com/api/v2/ResolveLegacy', {
      headers: {
        'x-api-key': ConfigurationValues.ConsumerKey,
      },
      params: {
        legacyCode,
        countryCode,
      },
    })
    .then((res) => res.data);
};
